"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInstanceGetters = exports.getFunctionGetters = exports.getPrototypeGetters = void 0;
// eslint-disable-next-line max-len
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function getPrototypeGetters(prototype, includeHertibaleGetters) {
    const prototypeGetters = Object
        .entries(Object.getOwnPropertyDescriptors(prototype))
        .map(entry => {
        const [prop, descriptor] = entry;
        if (typeof descriptor['get'] === 'function') {
            return prop;
        }
        return '';
    }).filter(prop => prop !== '');
    if (includeHertibaleGetters) {
        const parentPrototype = Object.getPrototypeOf(prototype);
        if (parentPrototype) {
            const parentPrototypeGetters = getPrototypeGetters(parentPrototype);
            return prototypeGetters.concat(parentPrototypeGetters.filter(prop => prototypeGetters.indexOf(prop) === -1));
        }
    }
    return prototypeGetters;
}
exports.getPrototypeGetters = getPrototypeGetters;
// eslint-disable-next-line @typescript-eslint/ban-types
function getFunctionGetters(constructor, includeHertibaleGetters) {
    return getPrototypeGetters(constructor.prototype, includeHertibaleGetters);
}
exports.getFunctionGetters = getFunctionGetters;
// eslint-disable-next-line @typescript-eslint/ban-types
function getInstanceGetters(that, includeHertibaleGetters = true) {
    return getFunctionGetters(that.constructor, includeHertibaleGetters);
}
exports.getInstanceGetters = getInstanceGetters;
//# sourceMappingURL=getGetters.js.map